import { supabase } from "../../../supabase";
import { store } from "../../../store";
import { actions as authActions } from "../slices/authSlice";
import { usersApi } from "../../users";
import { featuresApi } from "../../features";

export async function initAuthStateListener() {
  // Check for any active session on app startup
  const {
    data: { session },
  } = await supabase.auth.getSession();

  // Update the auth state in Redux based on initial session
  store.dispatch(
    authActions.setAuthState({
      isAuthenticated: !!session,
      userId: session?.user ? session.user.id : null,
    }),
  );

  // Set up the Supabase auth state listener for changes
  supabase.auth.onAuthStateChange((_, session) => {
    // DataFast is injected only on production
    if (window.datafast && session?.user?.email) {
      window.datafast("identify", {
        user_id: `${session.user.id}`,
        email: `${session.user.email}`,
        // Name might not be specified
        ...(session.user.user_metadata?.full_name && {
          name: `${session.user.user_metadata.full_name}`,
        }),
      });
    }

    store.dispatch(
      authActions.setAuthState({
        isAuthenticated: !!session,
        userId: session?.user ? session.user.id : null,
      }),
    );

    store.dispatch(usersApi.util.invalidateTags(["Users"]));
    store.dispatch(featuresApi.util.invalidateTags(["UserFeatures"]));
  });
}
